import editSvg from "../../assets/Icon/Edit.svg";

// 共通メニュー項目（/bizsol/* ページ用）
// 既存ルートのみ href を付与しています。未定義の画面は href なしで表示します。
export const bizsolMenuItems = [
  { label: "ダッシュボード", iconSrc: "", href: "/bizsol/dashboard" },
  { label: "患者様名簿", iconSrc: "", href: "/bizsol/patients-list" },
  { label: "医療機関一覧", iconSrc: "", href: "/bizsol/clinic-list" },
  { label: "企業一覧", iconSrc: "", href: "/bizsol/company-list" },
  { label: "検査機器管理", iconSrc: "", href: "/bizsol/device-management" },
  { label: "請求情報", iconSrc: "", href: "/bizsol/invoice-list" },
  { label: "予約一覧", iconSrc: "", href: "/bizsol/reservation-list" },
  { label: "基本設定", iconSrc: "", href: "/bizsol/basic-info" },
  {
    label: "パスワード変更",
    iconSrc: editSvg,
    href: "/bizsol/password-change",
  },
];
